import { UserResponse } from "@authory-packages/core";
import { EditableItem } from "../components/EditableSortableItems/EditableSortableItems.types";
import { SORTABLE_HOME_IDENTIFIER } from "../components/ProfileHero/V4ProfileHero.utils";
import { APPLICATION_ROUTES } from "../shared-logic/routes";
import { RequestHost } from "../types/headers";
import { isMainDomain } from "./domainRouting";
import { ProfileUserResponse } from "@authory-packages/core";

export const getAboutPagesWithhref = (
    requestHostHeader: RequestHost,
    editMode: boolean,
    user: UserResponse | ProfileUserResponse,
    smartShareUrl?: string
) => {
    const pagesWithHref: EditableItem[] = [
        {
            id: SORTABLE_HOME_IDENTIFIER,
            label: "Home",
            hasRules: false,
            href: !editMode ? getProfileUrl(user.slug, isMainDomain(requestHostHeader), smartShareUrl) : APPLICATION_ROUTES.PORTFOLIO_APP,
            hideSettings: true
        },
        ...user.aboutPages
            .sort((a, b) => a.order - b.order)
            .map((abtPage) => ({
                id: "id" in abtPage ? abtPage.id!.toString() : abtPage.slug,
                label: abtPage.name,
                hasRules: false,
                href: editMode ? undefined : getAboutPageUrl(user.slug, isMainDomain(requestHostHeader), abtPage.slug, smartShareUrl)
            }))
    ];

    return pagesWithHref;
};

const getAboutPageUrl = (authorSlug: string, isMainDomain: boolean, aboutPageSlug: string, smartShareUrl?: string) => {
    const computedAuthorSlug = isMainDomain ? authorSlug : "";

    if (!!smartShareUrl) {
        return APPLICATION_ROUTES.SMART_SHARE_ABOUT_PAGE.replace("[author]", computedAuthorSlug)
            .replace("[aboutPageSlug]", aboutPageSlug)
            .replace("[smartShareURL]", smartShareUrl);
    } else {
        return APPLICATION_ROUTES.ABOUT_PAGE.replace("[author]", computedAuthorSlug).replace("[aboutPageSlug]", aboutPageSlug);
    }
};

export const getProfileUrl = (authorSlug: string, isMainDomain: boolean, smartShareUrl?: string) => {
    const computedAuthorSlug = isMainDomain ? authorSlug : "";

    if (!!smartShareUrl) {
        return APPLICATION_ROUTES.SMART_SHARE_AUTHOR_PAGE.replace("[author]", computedAuthorSlug).replace("[smartShareURL]", smartShareUrl);
    } else {
        return APPLICATION_ROUTES.AUTHOR_PAGE.replace("[author]", computedAuthorSlug);
    }
};
